import shortid from "shortid";
import { formatDate } from "../../../../utils";
import { calculoReajuste } from "../../../reajuste-preco/add-reajuste-preco/add-reajuste-preco";

export class TabelaVenda {
  ativado = true;
  descricao = null;
  tipoTabela = "POR_PRODUTO";
  dataInicio = null;
  dataFim = null;
  horaInicio = null;
  horaFim = null;
  diasSemana = null;
  operacao = null;
  fator = null;
  intGrupoPessoaId = null;
  insertUserId = null;
  updateUserId = null;
  pessoaIds = [];
  meioPagamentoIds = [];
  itens = [];

  constructor(tabela = {}, id) {
    if (id) {
      this.id = id;
      if (Array.isArray(tabela.meioPagamentoIds) && tabela.meioPagamentoIds?.length) {
        this.meioPagamentoIds = tabela.meioPagamentoIds.map((m) =>
          Number(m.fatMeioPagamentoId)
        );
      }
      if (Array.isArray(tabela.pessoaIds) && tabela.pessoaIds?.length) {
        this.pessoaIds = tabela.pessoaIds.map((m) => Number(m.intPessoaId));
      }
      this.updateUserId = tabela?.updateUserId;
    }
    this.ativado = tabela.ativado ?? this.ativado;
    this.descricao = tabela.descricao ?? this.descricao;
    this.tipoTabela = tabela.tipoTabela ?? this.tipoTabela;
    this.dataInicio = tabela.dataInicio ? new Date(tabela.dataInicio) : null;
    this.dataFim = tabela.dataFim ? new Date(tabela.dataFim) : null;
    this.horaInicio = tabela.horaInicio ?? this.horaInicio;
    this.horaFim = tabela.horaFim ?? this.horaFim;
    this.diasSemana = Array.isArray(tabela.diasSemana)
      ? tabela.diasSemana.map((d) => Number(d))
      : [];
    this.intGrupoPessoaId = tabela.intGrupoPessoaId ?? this.intGrupoPessoaId;
    this.insertUserId = tabela?.insertUserId;
    this.operacao = tabela.operacao ?? this.operacao;
    this.fator = tabela.fator ?? this.fator;
    this.itens = Array.isArray(tabela.itens)
      ? tabela.itens.map((it) => new TabelaVendaItem(it))
      : [];
    this.precoAtual = tabela.precoAtual ?? null;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
    if (name === "precoPraticado" && this.precoAtual && this.operacao) {
      const precoAtual = parseFloat(this.precoAtual);
      const precoPraticado = parseFloat(value);
      if (!isNaN(precoAtual) && !isNaN(precoPraticado) && precoAtual !== 0) {
        let fatorCalculado;
        if (this.operacao === "somar") {
          fatorCalculado = ((precoPraticado - precoAtual) / precoAtual) * 100;
        } else if (this.operacao === "subtrair") {
          fatorCalculado = ((precoAtual - precoPraticado) / precoAtual) * 100;
        }
        this.fator = fatorCalculado !== undefined ? fatorCalculado : null;
      }
    }
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeDate(name, date) {
    this[name] = date != "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
  }

  setHandleChangeAutoCompleteMultiSelecting(name, values) {
    this[name] = Array.isArray(values)
      ? values.map((v) => Number(v?.id ?? v))
      : [];
  }

  setChangeItens(lista) {
    this.itens = Array.isArray(lista)
      ? lista.map((it) => new TabelaVendaItem(it))
      : [];
  }

  setOperacao(operacao, precoVendaProduto, configuracoes) {
    const precoBase = precoVendaProduto || this.precoAtual;
    this.precoPraticado = calculoReajuste(
      precoBase,
      this.fator,
      operacao,
      configuracoes
    );
    this.operacao = operacao;
  }

  setFator(fator, precoVendaProduto, configuracoes) {
    const precoBase = precoVendaProduto || this.precoAtual;
    this.precoPraticado = calculoReajuste(
      precoBase,
      fator,
      this.operacao,
      configuracoes
    );
    this.fator = fator;
  }
}

export class TabelaVendaItem {
  precoAtual = null;
  operacao = null;
  fator = null;
  precoPraticado = null;
  quantidadeMinima = null;
  estProdutoId = null;

  constructor(item = {}) {
    this.id = item.id ?? shortid.generate();
    this.precoAtual = item.precoAtual ?? null;
    this.operacao = item.operacao ?? null;
    this.fator = item.fator ?? null;
    this.precoPraticado = item.precoPraticado ?? null;
    this.quantidadeMinima = item.quantidadeMinima ?? null;
    this.estProdutoId = item.estProdutoId ?? null;
  }
}
